import apiActivationPagination from 'pages/ApiActivation/Pagination';
import { IStrategyGroupsApi } from 'api/DecisionEngine/StrategyGroupApi';

export default (strategyGroupsApi: IStrategyGroupsApi) => {
  return apiActivationPagination.getItemsFetcherMiddleware(async ({ selectedUpdaters, ...params }) => {
    return strategyGroupsApi.findGroups({
      updaters: selectedUpdaters.map(({ id }) => id),
      ...params,
    });
  });
};
